import { render, staticRenderFns } from "./EmailInsights.vue?vue&type=template&id=5c79a182&"
import script from "./EmailInsights.vue?vue&type=script&lang=js&"
export * from "./EmailInsights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports